import React, { useState } from 'react';
import { Button, Box, Grid, } from '@material-ui/core';

//import 'bootstrap/dist/css/bootstrap.min.css';

import useStyles from './useStyles'
import logo from "./../../images/footer.jpg";
import Image from "react-bootstrap/Image";

const StepperTemplate = ({ folio, nombreSolicitante }) => {

  const [activeStep, setActiveStep] = useState(0);

  /* con el array steps, controlo la cantidad de pasos que tendrá, se puede dejar como '' si no se quiere mostrar */

  const classes = useStyles();

  const [titulo, setTitulo] = useState('COMPROBANTE DE INGRESO')
  const [valorButton, setvalorButton] = useState('Siguiente')


  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  };

  const handleBack = () => {

    setActiveStep((prevActiveStep) => prevActiveStep - 1)

  };


  return (
    <>
    
    
          <h3 style={{ color: '#0064AC', fontSize: 28, fontWeight: 'bold', marginLeft: 45, padding: 20, marginBottom:50  }}>{titulo}</h3>
      
   
      
    
          <div style={{ textAlign: 'left', color: '#0064AC', fontSize: 20, marginLeft: 45  }}>
          <h3 style={{ color: '#0064AC', fontSize: 16, fontWeight: 'bold', padding: 10 }}>Estimado Sr(a). {nombreSolicitante}</h3>
              <h2 style={{ color: 'rgb(0, 0, 0)', fontSize: 16,  padding: 10 }}> 
                La Superintendencia de Salud a recibido con exito el ingreso de su solicitud de mediación entre  Aseguradoras y Cotizantes y/o Beneficiarios.
              </h2>
              <h3 style={{ color: '#0064AC', fontSize: 16, fontWeight: 'bold',  padding:10, marginBottom:50 }}>Su numero de folio es: {folio}</h3>  
           </div>
         
       
       
         <div style={{ textAlign: 'right', color: '#0064AC', fontSize: 20, paddingRight: 50 }}>
           <h3 style={{ color: 'rgb(0, 0, 0)', fontSize: 16, paddingRight: 10 }}> 
                Atentamentamente
           </h3>
           <h3 style={{ color: 'rgb(0, 0, 0)', fontSize: 16, paddingRight: 10}}> 
               Superintendencia de Salud
           </h3>
         </div>
       <Button style={{ margin: 20 }} variant="contained" color="primary"  onClick={() => { window.print() }} className={classes.button}>
              Imprimir
        </Button>
        <div style={{ textAlign: 'right', color: '#0064AC', fontSize: 20, paddingRight: 50 }}>
           <Image src={logo} className="logo-responsive" style={{ maxWidth: '6rem' }}  />
        </div>

        

     </>



  );
}
export default StepperTemplate;
